<template>
<div style="text-align: center">
  苏ICP备2025172266号
</div>
</template>

<script>
export default {
  name: "MainFooter"
}
</script>

<style scoped>

</style>
